const GlobalStyles = {
  global: {
    "&::-webkit-scrollbar": {
      width: "12px",
      height: "12px",
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar:horizontal": {
      height: "12px",
      borderRadius: "8px",
      backgroundColor: `transparent`,
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "8px",
      backgroundColor: `Secondary.100`,
      border: "3px solid transparent",
      backgroundClip: "content-box",
    },
    "&::-webkit-scrollbar-corner": {
      background: "transparent",
    },
    ".resizer": {
      position: "absolute",
      right: 0,
      top: 0,
      height: "100%",
      width: "3px",
      cursor: "col-resize",
      userSelect: "none",
      touchAction: "none",
    },
    ".resizer.isResizing": {
      background: "Secondary.500",
      opacity: 1,
    },
    "@media (hover: hover)": {
      ".resizer": {
        opacity: 0,
      },
      ":hover > .resizer": {
        opacity: 1,
      },
    },
    ".jse-status-bar": {
      position: "sticky",
      bottom: 0,
      zIndex: 1,
      background: "white",
    },
  },
}

export default GlobalStyles
